








import { Component } from "vue-property-decorator";
import WallBackground from "@/components/WallBackground.vue";
import StarBackground from "@/components/StarBackground.vue";
import AbstractScene from "@/components/AbstractScene.vue";
import OraoraComponent from "@/components/OraoraComponent.vue";
import { RARITY } from "@/constants";

@Component({
  components: {
    WallBackground,
    StarBackground,
    OraoraComponent,
  },
})
export default class PunchScene extends AbstractScene {
  get isJolyn(): boolean {
    return (
      this.result.findIndex(
        (v) => v.name.includes("徐倫") && v.rarity === RARITY.SSR
      ) >= 0
    );
  }
  timeoutForDone = 2000;
}
